import { useEffect } from 'react';
import { useStoreId } from '@thd-nucleus/experience-context';
import { useDataModel } from '@thd-nucleus/data-sources';
import { determineItemOrItemTypes } from './utils';

export const useIsMajorAppliance = ({
  itemId,
  itemIds,
  storeId,
  responseOnly,
  isMajorAppliance,
  isPickupDrawer
}) => {
  const expStoreId = useStoreId();
  const storeIdToUse = storeId || expStoreId;

  if (typeof isMajorAppliance === 'boolean') {
    return {
      isMajorApplianceItemOrItems: isMajorAppliance,
      loading: null,
      error: null
    };
  }

  if (responseOnly || isMajorAppliance || isPickupDrawer) {
    return {
      isMajorApplianceItemOrItems: isMajorAppliance || null,
      loading: null,
      error: null
    };
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [getProducts, productsResponse] = useDataModel('clientOnlyProducts', {
    variables: {
      itemIds: (itemId ? [itemId] : itemIds)
    },
    ssr: false,
    skip: storeIdToUse === '8119'
  }, true);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    getProducts();
  }, [itemIds, itemId]);
  const { data, loading, error } = productsResponse;

  return {
    isMajorApplianceItemOrItems: determineItemOrItemTypes(data),
    loading,
    error
  };
};
